import { createContext, useContext, useEffect, useState, ReactNode } from "react";
import { ListLangs } from "./Langs";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";

type LanguageContextType = {
  t: TFunction;
  i18n: any;
  onClickLanguageChange: (lang: string) => void;
  ListLangs: Record<string, string>;
};

export const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageContextProvider = ({ children }: { children: ReactNode }) => {
  const [language, setChangeLanguage] = useState("EN");

  const { t, i18n } = useTranslation();

const onClickLanguageChange = (lang: string) => {
  i18n.changeLanguage(lang);
  setChangeLanguage(lang);
  localStorage.setItem("current-lang-page", JSON.stringify(lang));
};

  useEffect(() => {
  const selectedLanguage = localStorage.getItem("current-lang-page");
  if (selectedLanguage) {
    i18n.changeLanguage(JSON.parse(selectedLanguage));
  }
}, [i18n, language]);

  return (
    <LanguageContext.Provider
      value={{ t, i18n, onClickLanguageChange, ListLangs }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguageContext = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error(
      "useLanguageContext must be used inside LanguageContextProvider"
    );
  }
  return ctx;
};
